module.exports = __webpack_public_path__ + "static/media/aedc.2fe232fa.svg";